import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ tokens, px }) => ({
  chip: {
    height: px(32),
    paddingLeft: tokens.spacing['12'],
    paddingRight: tokens.spacing['12'],
    paddingTop: tokens.spacing['8'],
    paddingBottom: tokens.spacing['8'],
    backgroundColor: 'transparent',
    borderColor: tokens.colors.stroke.primary,
    cursor: 'pointer',

    '& .MuiChip-label': {
      display: 'flex',
      padding: 0,
      color: tokens.colors.text.light.primary,
      ...tokens.typography.variant.body3,
    },

    '&.MuiChip-outlined:hover:not(.Mui-disabled)': {
      backgroundColor: 'transparent',
    },
  },

  active: {
    backgroundColor: tokens.colors.original.brand.secondary,
    borderColor: tokens.colors.original.brand.primary,

    '& .MuiChip-label': {
      color: tokens.colors.original.brand.primary,
    },

    '&.MuiChip-outlined:hover:not(.Mui-disabled)': {
      backgroundColor: tokens.colors.original.brand.quaternary,
    },
  },
}));
